const DashboardListingSkeleton = () => {
    return (
        <div class="section">
            <div class="card skeleton">
                <div class="card-left">
                    <div class="icon-skeleton skeleton"></div>
                    <div class="text-block">
                        <div class="line-md skeleton"></div>
                        <div class="line-sm skeleton"></div>
                    </div>
                </div>
                <div class="card-right">
                    <div class="line-right-lg skeleton"></div>
                    <div class="line-right-sm skeleton"></div>
                </div>
            </div>
            <div class="card skeleton">
                <div class="card-left">
                    <div class="icon-skeleton skeleton"></div>
                    <div class="text-block">
                        <div class="line-md skeleton"></div>
                        <div class="line-sm skeleton"></div>
                    </div>
                </div>
                <div class="card-right">
                    <div class="line-right-lg skeleton"></div>
                    <div class="line-right-sm skeleton"></div>
                </div>
            </div>
            <div class="card skeleton">
                <div class="card-left">
                    <div class="icon-skeleton skeleton"></div>
                    <div class="text-block">
                        <div class="line-md skeleton"></div>
                        <div class="line-sm skeleton"></div>
                    </div>
                </div>
                <div class="card-right">
                    <div class="line-right-lg skeleton"></div>
                    <div class="line-right-sm skeleton"></div>
                </div>
            </div>
            <div class="card skeleton">
                <div class="card-left">
                    <div class="icon-skeleton skeleton"></div>
                    <div class="text-block">
                        <div class="line-md skeleton"></div>
                        <div class="line-sm skeleton"></div>
                    </div>
                </div>
                <div class="card-right">
                    <div class="line-right-lg skeleton"></div>
                    <div class="line-right-sm skeleton"></div>
                </div>
            </div>
            <div class="card skeleton">
                <div class="card-left">
                    <div class="icon-skeleton skeleton"></div>
                    <div class="text-block">
                        <div class="line-md skeleton"></div>
                        <div class="line-sm skeleton"></div>
                    </div>
                </div>
                <div class="card-right">
                    <div class="line-right-lg skeleton"></div>
                    <div class="line-right-sm skeleton"></div>
                </div>
            </div>
            <div class="card skeleton">
                <div class="card-left">
                    <div class="icon-skeleton skeleton"></div>
                    <div class="text-block">
                        <div class="line-md skeleton"></div>
                        <div class="line-sm skeleton"></div>
                    </div>
                </div>
                <div class="card-right">
                    <div class="line-right-lg skeleton"></div>
                    <div class="line-right-sm skeleton"></div>
                </div>
            </div>
            <div class="card skeleton">
                <div class="card-left">
                    <div class="icon-skeleton skeleton"></div>
                    <div class="text-block">
                        <div class="line-md skeleton"></div>
                        <div class="line-sm skeleton"></div>
                    </div>
                </div>
                <div class="card-right">
                    <div class="line-right-lg skeleton"></div>
                    <div class="line-right-sm skeleton"></div>
                </div>
            </div>
            <div class="card skeleton">
                <div class="card-left">
                    <div class="icon-skeleton skeleton"></div>
                    <div class="text-block">
                        <div class="line-md skeleton"></div>
                        <div class="line-sm skeleton"></div>
                    </div>
                </div>
                <div class="card-right">
                    <div class="line-right-lg skeleton"></div>
                    <div class="line-right-sm skeleton"></div>
                </div>
            </div>
            <div class="card skeleton">
                <div class="card-left">
                    <div class="icon-skeleton skeleton"></div>
                    <div class="text-block">
                        <div class="line-md skeleton"></div>
                        <div class="line-sm skeleton"></div>
                    </div>
                </div>
                <div class="card-right">
                    <div class="line-right-lg skeleton"></div>
                    <div class="line-right-sm skeleton"></div>
                </div>
            </div>
        </div>
    )
}

export default DashboardListingSkeleton